import React, { useEffect } from 'react';
import { signInWithRedirect } from '@aws-amplify/auth';

const SignUp: React.FC = () => {
  useEffect(() => {
    // Redirect to Cognito hosted UI for sign up
    const initiateSignUp = async () => {
      try {
        // Use signInWithRedirect without parameters
        // We'll configure the AuthContext to handle sign-up properly
        await signInWithRedirect();
        
      } catch (error) {
        console.error('Error redirecting to sign up:', error);
      }
    };
    
    initiateSignUp();
  }, []);

  // Loading screen shown briefly before redirect
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="w-full max-w-md p-8 space-y-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Signing Up</h1>
          <p className="text-base text-gray-600 dark:text-gray-400">
            Redirecting to registration service...
          </p>
        </div>
        
        <div className="flex justify-center mt-6">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
